<template>
  <div class="flex justify-between md:justify-around mb-6 pt-8 relative z-10">
    <img src="../assets/images/svg/rzd.svg" alt="RZD Logo" class="h-auto p-4 md:p-0" />
    <img src="../assets/images/svg/sapsan.svg" alt="Sapsan Logo" class="h-auto p-4 md:p-0" />
  </div>
</template>
